import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "site-header" }
const _hoisted_2 = { class: "header-inner" }

import { computed } from "vue";
import { storeToRefs } from "pinia";
import { IconPlus } from "@arco-design/web-vue/es/icon";
import { useLoginUserStore } from "@/store/userStore";
import { useAuthModal } from "@/composables/useAuthModal";

export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  setup(__props) {

const store = useLoginUserStore(),
  { loginUser } = storeToRefs(store),
  isAdmin = computed(() =>
    ["admin", "super_admin"].includes(loginUser.value?.userRole || "")
  ),
  { show: openAuth } = useAuthModal();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "home-mark",
        to: "/",
        "aria-label": "KomeiC 首页"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("i", null, [
            _createElementVNode("span"),
            _createElementVNode("span"),
            _createElementVNode("span")
          ], -1),
          _createElementVNode("b", null, "KomeiC", -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("nav", null, [
        (isAdmin.value)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/admin"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("管理", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_unref(loginUser)?.id)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "nav-btn",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openAuth)()))
            }, "登录"))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              to: "/account"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("我的", -1)
              ]))]),
              _: 1
            })),
        _createVNode(_component_router_link, {
          class: "create",
          to: "/space/create"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IconPlus)),
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "创建", -1))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})